module.exports = __webpack_public_path__ + "img/service20.eff51de6.svg";